import React, { memo } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

// ⚡ Bolt: Wrapped SafeIcon in React.memo to prevent unnecessary re-renders.
// SafeIcon is heavily used in lists (e.g., RecentActivity, Sidebar, CampaignList)
// and its props are typically static. This optimization reduces the render tree depth.
const SafeIcon = memo(({ icon: Icon, ...props }) => {
  // If an icon component is passed directly, render it.
  // Otherwise, render a fallback icon.
  return Icon ? <Icon {...props} /> : <FiAlertTriangle {...props} />;
});

// Add display name for React DevTools
SafeIcon.displayName = 'SafeIcon';

export default SafeIcon;
